export default () => ({
  title: "",
  medicalSpecialties:[],
  medicalSpecialty:null,
  medicalSpecialtyToEdit: '',
  status: '',
  total: "",
});
